module.exports = __webpack_public_path__ + "static/apple-icon-152x152-712865265f3ee5048fcc7e12e08c16e6.png";